const noop = () => {}

export { noop }
